import { useSelector } from "react-redux";

export const useGetPermission = (key) => {
  const { permissions, loading } = useSelector((state) => state?.permission);

  const initialState = {
    list: true,
    add: true,
    edit: true,
    details: true,
    delete: true,
    changeStatus: true,
    changeOrder: true,
  };
  const find_permission = permissions?.find((item) => item?.code === key)?.type;

  if (!loading) {
    if (find_permission && Object.keys(find_permission)?.length > 0) {
      return { permission: find_permission, status: "ok" };
    } else {
      return { permission: initialState, status: "ok" };
    }
  } else {
    return { permission: null, status: "loading" };
  }
};
